/**
 * Lazy Loading Images
 * Adds native lazy loading and IntersectionObserver fallback for older browsers
 */

(function() {
  'use strict';

  // Add loading="lazy" to all images in post content
  function addLazyLoadingToImages() {
    const contentImages = document.querySelectorAll('.post-content img, .archive-content img');

    contentImages.forEach(img => {
      // Add native lazy loading attribute if not already present
      if (!img.hasAttribute('loading')) {
        img.setAttribute('loading', 'lazy');
      }

      // Add decoding attribute for better performance
      if (!img.hasAttribute('decoding')) {
        img.setAttribute('decoding', 'async');
      }
    });
  }

  // IntersectionObserver fallback for browsers that don't support native lazy loading
  function setupIntersectionObserver() {
    // Check if browser supports native lazy loading
    if ('loading' in HTMLImageElement.prototype) {
      return; // Native lazy loading is supported, no need for fallback
    }

    // Fallback using IntersectionObserver
    const lazyImages = document.querySelectorAll('img[loading="lazy"]');

    if ('IntersectionObserver' in window) {
      const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;

            // Load the image
            if (img.dataset.src) {
              img.src = img.dataset.src;
              img.removeAttribute('data-src');
            }

            // Load srcset if available
            if (img.dataset.srcset) {
              img.srcset = img.dataset.srcset;
              img.removeAttribute('data-srcset');
            }

            img.classList.add('lazy-loaded');
            observer.unobserve(img);
          }
        });
      }, {
        rootMargin: '50px 0px', // Start loading 50px before entering viewport
        threshold: 0.01
      });

      lazyImages.forEach(img => {
        imageObserver.observe(img);
      });
    } else {
      // Fallback for browsers without IntersectionObserver - load all images immediately
      lazyImages.forEach(img => {
        if (img.dataset.src) {
          img.src = img.dataset.src;
        }
        if (img.dataset.srcset) {
          img.srcset = img.dataset.srcset;
        }
      });
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      addLazyLoadingToImages();
      setupIntersectionObserver();
    });
  } else {
    addLazyLoadingToImages();
    setupIntersectionObserver();
  }
})();
